import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const AppContainer = styled.div`
  background-color: #f5f7fa;
  min-height: 100vh;
  display: flex;
  font-family: 'Nunito', sans-serif;
`;

export const GlobalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap');

  * {
    font-family: 'Nunito', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    ::-webkit-scrollbar {
      width: 16px;
      height: 16px;
      background-color: transparent;
    }

    ::-webkit-scrollbar-track {
      background: rgba(189, 189, 189, 0.5);
      margin: 0 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(200, 200, 200, 0.7);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: rgba(160, 160, 160, 0.7);
    }

    ::-webkit-scrollbar-thumb:active {
      background: rgba(120, 120, 120, 0.7);
    }

    ::-webkit-scrollbar-button {
      display: none;
      width: 0;
      height: 0;
    }

    html {
      scrollbar-width: thin;
      scrollbar-color: rgba(200, 200, 200, 0.7) rgba(189, 189, 189, 0.5);
    }
  }

  body {
    overflow: overlay;
  }
`;

export const SidebarContainer = styled.div`
  width: 100%;
  @media (min-width: 1200px) {
    width: 300px;
  }
  @media (min-width: 1536px) {
    width: 300px;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  margin-left: 0;
  padding-top: 0;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  margin-top: 24px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: 100vw;
  }
`;
